<template>
  <div id="hj-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-section">
      <div class="container">
        <el-breadcrumb separator=">">
          <el-breadcrumb-item :to="{ path: '/pc/mall' }">商城首页</el-breadcrumb-item>
          <el-breadcrumb-item>全部商品</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- 筛选条件 -->
    <div class="filter-section">
      <div class="container">
        <commonSearch @search="handleSearch" :inputValue="searchKeyword" />
        <!-- <div class="filter-row">
          <span class="filter-label">商品分类:</span>
          <div class="filter-options">
            <span :class="['filter-option', selectedBrand === '' ? 'active' : '']" @click="selectBrand('')">全部</span>
            <span v-for="brand in brands" :key="brand.id" :class="['filter-option', selectedBrand === brand.id ? 'active' : '']" @click="selectBrand(brand.id)">
              {{ brand.name }}
            </span>
          </div>
        </div> -->

        <!-- <div class="filter-row">
          <span class="filter-label">销量:</span>
          <div class="filter-options">
            <span :class="['filter-option', selectedSales === '' ? 'active' : '']" @click="selectSales('')">不限</span>
            <span :class="['filter-option', selectedSales === 'high' ? 'active' : '']" @click="selectSales('high')">销量</span>
            <span :class="['filter-option', selectedSales === 'rating' ? 'active' : '']" @click="selectSales('rating')">评分</span>
            <span :class="['filter-option', selectedSales === 'price' ? 'active' : '']" @click="selectSales('price')">价格</span>
          </div>
        </div> -->

        <!-- <div class="filter-row">
          <span class="filter-label">排序:</span>
          <div class="filter-options">
            <span :class="['filter-option', sortBy === 'default' ? 'active' : '']" @click="sortBy = 'default'">默认</span>
            <span :class="['filter-option', sortBy === 'sales' ? 'active' : '']" @click="sortBy = 'sales'">销量</span>
            <span :class="['filter-option', sortBy === 'price-asc' ? 'active' : '']" @click="sortBy = 'price-asc'">价格 ↑</span>
            <span :class="['filter-option', sortBy === 'price-desc' ? 'active' : '']" @click="sortBy = 'price-desc'">价格 ↓</span>
          </div>
          <div class="result-count">共找到 {{ filteredProducts.length }} 件商品</div>
        </div> -->
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="products-grid-section">
      <div class="container">
        <div class="products-grid">
          <product-card v-for="product in products" :key="product.id" :product="product" @click="goToProduct(product.id)" />
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="currentPage" @current-change="handlePageChange"> </el-pagination>
        </div>
      </div>
    </div>

    <footer-layout></footer-layout>
  </div>
</template>

<script>
import FooterLayout from '@/components/pc/FooterLayout.vue'
import commonSearch from './components/commonSearch.vue'
import ProductCard from './components/ProductCard.vue'
import mall from '@/api/mall'
export default {
  name: 'MallProducts',
  components: { FooterLayout, commonSearch, ProductCard },
  data() {
    return {
      searchKeyword: '',
      selectedBrand: '',
      selectedSales: '',
      sortBy: 'default',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      brands: [
        { id: 1, name: '强生' },
        { id: 2, name: '3M' },
        { id: 3, name: '拜耳' },
        { id: 4, name: '罗氏' },
        { id: 5, name: '迈瑞' }
      ],
      products: []
    }
  },
  mounted() {
    this.searchKeyword = this.$route.query.keyword || ''
    //接口查询keywords商品
    this.handleSearch(this.searchKeyword)
  },
  methods: {
    handleSearch(keyword) {
      //掉接口获取商品
      this.getProductList(keyword)
    },
    selectBrand(brandId) {
      this.selectedBrand = brandId
      this.currentPage = 1
    },
    //获取【商品列表】
    getProductList(keyword) {
      const params = {
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        productName: keyword || '',
        channelCode: this.$local.get('channelCode')
      }
      mall.getAllProduct(params).then((res) => {
        console.log('商品列表', res.data.data)
        this.products = res.data.data
      })
    },
    //获取品类【商品列表】
    getPartProductList(id) {
      const params = {
        frontCateId: id, //前端类目ID
        pageNumber: 1, //页码
        pageSize: 6, //页大小
        channelCode: this.$local.get('channelCode')
      }
      mall.getProductCategoryList(params).then((res) => {
        console.log('分类广场商品列表', res.data.data)
        this.displayCategories[index].products = res.data.data
      })
    },
    handlePageChange(page) {
      this.currentPage = page
      // 滚动到顶部
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    goToProduct(productId) {
      this.$router.push(`/pc/mall/product/${productId}`)
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.breadcrumb-section {
  background: #f8f9fa;
  padding: 10px 0;

  ::v-deep .el-breadcrumb {
    font-size: 14px;

    .el-breadcrumb__item__inner {
      color: #666;

      &:hover {
        color: #409eff;
      }
    }

    .el-breadcrumb__item:last-child .el-breadcrumb__inner {
      color: #409eff;
    }
  }
}

.filter-section {
  background: white;
  border-bottom: 1px solid #e5e5e5;
  padding: 20px 0;

  .filter-row {
    display: flex;
    align-items: center;
    margin: 25px 0;

    &:last-child {
      margin-bottom: 0;
      justify-content: flex-start;
    }

    .filter-label {
      color: #333;
      font-weight: bold;
      width: 80px;
      flex-shrink: 0;
      text-align: left;
    }

    .filter-options {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .filter-option {
        padding: 5px 15px;
        margin-right: 10px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          color: #409eff;
        }

        &.active {
          background: #409eff;
          color: white;
          border-color: #409eff;
        }
      }
    }

    .result-count {
      color: #666;
      font-size: 14px;
    }
  }
}

.products-grid-section {
  padding: 30px 0;
  min-height: 600px;

  .products-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 20px;
    margin-bottom: 40px;

    .product-card {
      background: white;
      border: 1px solid #e5e5e5;
      border-radius: 8px;
      overflow: hidden;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }

      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
      }

      .product-info {
        padding: 15px;

        h4 {
          font-size: 16px;
          margin: 0 0 10px 0;
          color: #333;
          height: 44px;
          overflow: hidden;
          line-height: 22px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .product-price {
          color: #e74c3c;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 8px;
        }

        .product-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .product-sales {
            color: #999;
            font-size: 12px;
          }

          .product-rating {
            i {
              font-size: 12px;

              &.el-icon-star-on {
                color: #ffa500;
              }

              &.el-icon-star-off {
                color: #ddd;
              }
            }
          }
        }
      }
    }
  }

  .pagination-section {
    text-align: center;

    ::v-deep .el-pagination {
      .el-pager li.active {
        background-color: #409eff;
        color: white;
      }
    }
  }
}
</style>
